<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="name"
              rules="required"
            >
              <b-form-group label="Primeiro Nome" label-for="v-name">
                <b-form-input
                  id="v-name"
                  v-model="form.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="
                    (!verificarPermissao('ROLE_PERFIL_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_PERFIL_INSERIR') && !form.id)
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- email -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="Permissões"
              rules="required"
            >
              <b-form-group label="Permissões" label-for="v-role">
                <v-select
                  v-model="form.roles"
                  label="authority"
                  :options="comboPermissionsProfile"
                  :state="errors.length > 0 ? false : null"
                  multiple
                  :disabled="
                    (!verificarPermissao('ROLE_PERFIL_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_PERFIL_INSERIR') && !form.id)
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_PERFIL_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_PERFIL_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import mixinsGlobal from '@/mixins'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('profileSettingAccessModule', {
      profile: (state) => state.profile
    }),
    ...mapState('combosModule', {
      comboPermissionsProfile: (state) => state.comboPermissionsProfile
    })
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue
  },
  directives: {
    Ripple
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Usuarios',
      required,
      form: {
        nome: '',
        roles: []
      }
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.profile))
    this.$store.dispatch('combosModule/loadComboPermissionsProfile')
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('profileSettingAccessModule/reset')
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          const obj = JSON.parse(JSON.stringify(this.form))
          if (this.form.id) {
            this.$store
              .dispatch('profileSettingAccessModule/edit', obj)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('profileSettingAccessModule/insert', obj)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        nome: '',
        roles: []
      }
    }
  }
}
</script>
